import Phaser, {
    Display
} from 'phaser'
import gsap from "gsap";


let container;
let gameScale;
let content;
let tooltip;
let rect;
let tri;
let _this;
let padding;
let tags;
let styles;
let isMobile;
let isSmall = false;
let tooltipClone;

export default class ToolTips extends Phaser.Scene {
    constructor() {
        super('toolTips')
    }
    init(data) {

        container = data.container;
    }

    create() {
        gameScale = this.registry.values.scaleIt;
        isMobile = this.registry.values.isMobile;
        if (window.screen.width < 700) isSmall = true;
        _this = this;

        padding = 10 * gameScale;

        this.createGraphic();
        this.startTips(container);

    }

    //Create the interactive functionality to show tooltip
    startTips(holder) {

        //Hold ALL the children from container that was passed in init 
        let arr = holder.getAll();

        let obj;
        let hit;
        let navigate = this.scene.get('navigate');
        //run through child list and find the ones that have tooltip data: english & maori
        for (let index = 0; index < arr.length; index++) {

            obj = arr[index];
            //If there is no language settings it's not a tooltip, moving on.
            if (!obj.getData('english')) continue;

            //Generate a shape to use as hit area
            hit = this.createPoly(obj);

            obj.setInteractive({
                hitArea: hit,
                hitAreaCallback: Phaser.Geom.Polygon.Contains,
                //useHandCursor: true
            });

            if (obj.getData('location')) {
                holder.bringToTop(obj);
                navigate.setupLocation({
                    obj: obj
                });
            } else {
                obj.on('pointerover', this.onTool.bind(obj, obj));
                obj.on('pointerout', this.outTool);
            }

            //this.input.enableDebug(obj, 0xff0000);
            //    }


        }

    }


    createPoly(obj) {
        let hit = obj.getData('hit');

        //if there is not hit data on the image we'll return undefined to use default rectangle hit area
        if (!hit) return (hit);

        //hold the polygon
        let poly = new Phaser.Geom.Polygon(hit);

        //new coordinates based on gamescale    
        let scaledpoly = new Array;
        //find the scaled coordinates
        for (let index = 0; index < poly.points.length; index++) {
            scaledpoly.push([poly.points[index].x * gameScale, poly.points[index].y * gameScale]);
        }
        //adjust polygon based on scaled coordinates
        if (obj.flipX) scaledpoly = this.flipPoly(scaledpoly);
        poly.setTo(scaledpoly);


        //send it back to become hitarea
        return (poly);
    }

    flipPoly(coords) {
        //Hold numbers for clarity
        let minX;
        let maxX;
        let midX;
        let thisX;
        let diff;

        //find the outer most x coordinates
        for (let index = 0; index < coords.length; index++) {
            thisX = coords[index][0];
            if (thisX < minX || !minX) {
                minX = thisX;
            }

            if (thisX > maxX || !maxX) {
                maxX = thisX;
            }

        }

        //calculate the midpoint of the polygon coordinates
        midX = (maxX - minX) / 2 + minX;
        //adjust all the x coordinates to flip them to the opposite side of the midline
        for (let index = 0; index < coords.length; index++) {
            thisX = coords[index][0];
            diff = thisX - midX;

            if (diff > 0) {
                thisX = midX - diff;
            } else {
                thisX = midX + (-1 * diff);
            }
            coords[index][0] = thisX;
        }

        return (coords);

    }

    updateToolTip(english, maori) {

        content.setText("");
        if (maori) {
            content = this.add.rexTagText(0, 0, maori + '\n<class="altText">' + english + '</class>', styles);
        } else {
            content = this.add.rexTagText(0, 0, english, styles);
        }
        tooltip.add(content);
        content.x = content.y = padding;
        //rect.clear();
        // rect.setEmpty();
        //rect.fillStyle(0xD3C47A, 0.9);
        //rect.fillRoundedRect(0, 0, content.width + padding * 2, content.height + padding * 2, 18);
        rect.x = rect.y = 0;
        rect.setSize(content.width + padding * 3, content.height + padding * 3);
        tri.x = content.width / 2;
        tri.y = content.height + padding * 2;

        //Clone the image that was just clicked
        tooltip.visible = false;
        tooltipClone = this.add.renderTexture(0, 0, content.width + padding * 2, content.height + padding * 2 + 10 * gameScale);

        //draw the render of this image
        tooltipClone.draw(tooltip, 0, 0);


        //put the image back to correct scale
        this.pointermove();
    }
    pointermove() {
        //tooltip.x = this.input.activePointer.x - tooltip.getBounds().width / 2 - 2 * gameScale;
        tooltipClone.x = this.input.activePointer.x - tooltipClone.width / 2 - 2 * gameScale;

        let padY = padding * 2.5;
        if (isMobile) padY = padding * 6;
        if (isSmall) padY = padding * 16;
        //tooltip.y = this.input.activePointer.y - padY - tooltip.getBounds().height;
        tooltipClone.y = this.input.activePointer.y - padY - tooltipClone.height;
    }


    onTool(obj) {
        if (!obj.getData('english')) return;
        _this.updateToolTip(obj.getData('english'), obj.getData('maori'));
        gsap.to(tooltip, {
            duration: 0.15,
            alpha: 1
        })
        _this.input.on('pointermove', _this.pointermove, _this);
    }

    outTool() {
        if (tooltipClone) {
            gsap.to(tooltipClone, {
                duration: 0.15,
                alpha: 0
            })
        }
        _this.input.removeAllListeners();
    }

    createGraphic() {

        content = this.make.rexTagText({});
        tags = {
            altText: {
                color: '#F7EAAD',

            }
        };
        let fontSize = 18 * gameScale;
        if (isSmall) {
            fontSize = 28;
        }

        styles = {
            fontFamily: 'maori, serif',
            fontSize: fontSize,
            color: '#FFFFFF',
            align: 'left',
            whiteSpace: 'normal',
            tags: tags
        };

        //content = this.add.rexTagText(0, 0, 'harakeke\n<class="altText">flax</class>', styles);
        content = this.add.rexTagText(0, 0, '', styles);

        /*
                rect = this.add.graphics();
                rect.fillStyle(0xD3C47A, 0.9);
                rect.fillRoundedRect(0, 0, content.width + padding * 2, content.height + padding * 2, 18);
        */
        rect = this.add.rectangle(0, 0, content.width + padding * 2, content.height + padding * 2, 0xD3C47A);
        rect.setAlpha(0.9);
        tri = this.add.graphics();
        tri.fillStyle(0xD3C47A, 0.9);
        tri.fillTriangle(0, 0, 20 * gameScale, 0, 10 * gameScale, 10 * gameScale);
        //tri = this.add.triangle(0, 0, 200 * gameScale, 0, 100 * gameScale, 100 * gameScale);
        // tri.setAlpha(0.9);
        tooltip = this.add.container(0, 0);
        tooltip.add(rect);
        tooltip.add(tri);
        tooltip.add(content);
        tooltip.alpha = 0;

        //tooltip.setDepth(300);
    }

}